import { Button, Divider, Modal, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, games, bgColor, accentColor }) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '70%', md: '50%' },
          maxHeight: '80vh',
          bgcolor: bgColor,
          display: 'flex',
          flexDirection: 'column',
          p: { xs: 2, sm: 4 },
        }}
      >
        <Typography sx={{ fontSize: { xs: '18px', sm: '22px' }, color: '#FFFFFF', mb: 1.5, flexShrink: 0 }}>
          {t('confirmation.title')}
        </Typography>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', mb: 2, flexShrink: 0 }} />
        <Box sx={{ overflowY: 'auto', flex: 1, mb: 2 }}>
          {games
            .filter(g => g.quantity != null && g.quantity !== '')
            .map(g => (
              <Box
                key={g.gameId}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  borderRadius: 1,
                  px: 2,
                  py: 1.25,
                  mb: 1,
                }}
              >
                <Typography sx={{ color: '#FFFFFF', fontSize: '14px' }}>
                  {g.display}
                </Typography>
                <Typography
                  sx={{
                    color: accentColor,
                    fontWeight: 'bold',
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ml: 2,
                  }}
                >
                  {t('quantity_packs', { count: g.quantity })}
                </Typography>
              </Box>
            ))}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, flexShrink: 0 }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: 'rgba(255,255,255,0.15)', color: '#FFFFFF' }}
            onClick={onClose}
          >
            {t('survey.no')}
          </Button>
          <Button
            variant='contained'
            sx={{ backgroundColor: accentColor, color: '#FFFFFF' }}
            onClick={onConfirm}
          >
            {t('survey.yes')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
